import { makeStyles } from '@material-ui/core/styles';
import React, { FC, useCallback, useMemo } from 'react';

import { Button } from '~/@components/Button';
import { LocalizableText } from '~/@components/LocalizableText';
import { PageWrapper } from '~/@sochi-components/PageWrapper';
import { SochiTitle } from '~/@sochi-components/SochiTitle';
import { projectTimeSpentStore } from '~/@user-store/timeSpent/timeSpentStore';
import { showProjectTimeSpentDialog } from '~/@views/UserView/ProjectPage/ProjectTimeSpent/ProjectTimeSpentEditForm/ProjectTimeSpentDialog';
import { ProjectTimeSpentTable } from '~/@views/UserView/ProjectPage/ProjectTimeSpent/ProjectTimeSpentTable';
import { Project } from '~/@views/UserView/ProjectPage/ProjectTimeSpent/types';
import { useUserAbilities } from '~/contexts';
import { canCreateTimeSpent } from '~/utils/auth';
import { downloadProjectTimeSpentXlsx } from '~/utils/project';

type Props = {
    project: Project;
};

export const ProjectTimeSpent: FC<Props> = ({ project }) => {
    const { root } = useStyles();

    const ability = useUserAbilities();

    const canCreate = useMemo(() => canCreateTimeSpent(ability, project), [project, ability]);

    const download = useCallback(() => {
        const ignoredPromise = downloadProjectTimeSpentXlsx(
            project.id,
            project.name,
            projectTimeSpentStore.filteredList.map(i => i.id)
        );
    }, [project]);

    return (
        <PageWrapper>
            <div className={root}>
                <SochiTitle title={<LocalizableText code={'ProjectDocuments.timeSpent.title'} />}>
                    <Button
                        onClick={() => showProjectTimeSpentDialog(project, null)}
                        disabled={!canCreate}
                        color={'primary'}
                        variant="contained">
                        <LocalizableText code={'add'} />
                    </Button>
                    <Button onClick={download} color={'primary'} variant="contained">
                        <LocalizableText code={'download'} />
                    </Button>
                </SochiTitle>
                <ProjectTimeSpentTable project={project} />
            </div>
        </PageWrapper>
    );
};

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
}));
